export const plugins = [{
    plugin: require('bernie-plugin-isomorphic-logger/dist/browser'),
    options: JSON.parse('{}') 
  },{
    plugin: require('bernie-plugin-apollo/dist/browser'),
    options: JSON.parse('{}') 
  },{
    plugin: require('bernie-plugin-clickstream/dist/browser'),
    options: JSON.parse('{"brandClickstream":"uis-prime"}') 
  }]